import script from "./checkbox-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./checkbox-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./checkbox-setting-ly.vue?vue&type=style&index=0&id=18965ecb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18965ecb"]])

export default __exports__